module.exports = "pegasus_template/assets/theme6/small/1.jpg";